import { combineReducers } from 'redux';

import { activateGeozone, createGeozone, deleteGeozone, loadGeozones, updateGeozoneFinished } from '../sagas/geozones/actions';
import { changeCurrentDevice } from '../components/Header/actions';
import { editGeozoneClicked, toggleGeozoneEditor } from '../components/Modal/GeozonesModal/actions';
import { switchCurrentDevice, toggleSettingsModal } from '../components/Modal/actions';
import { logoutButtonClick } from '../components/Auth/actions';

const defaultGeozone = {
  id: -1,
  name: '',
  wkt: '',
  weekly: {},
};

const geozonesLoading = (state = true, action) => {
  if (action.type === loadGeozones.started.type) {
    return true;
  }
  if (action.type === loadGeozones.done.type) {
    return false;
  }
  if (action.type === loadGeozones.failed.type) {
    return false;
  }
  return state;
};

const currentDeviceGeozones = (state = [], action) => {
  if (action.type === loadGeozones.done.type) {
    return action.payload.result.data;
  }

  if (action.type === deleteGeozone.started.type) {
    const geozoneId = action.payload.GeozoneId;
    return state.map(geozone => (geozone.id !== geozoneId ? geozone : { ...geozone, deleting: true }));
  }

  if (action.type === deleteGeozone.done.type) {
    const geozoneId = action.payload.params.GeozoneId;
    return state.filter(({ id }) => id !== geozoneId);
  }

  if (action.type === deleteGeozone.failed.type) {
    const geozoneId = action.payload.params.GeozoneId;
    return state.map(geozone => (geozone.id !== geozoneId ? geozone : { ...geozone, deleting: false }));
  }

  if (action.type === activateGeozone.done.type) {
    const index = state.findIndex(x => x.id === action.payload.params.GeozoneId);
    const newGeozone = { ...state[index] };
    newGeozone.isEnabled = !newGeozone.isEnabled;
    state.splice(index, 1, newGeozone);
    return [...state];
  }

  if (action.type === changeCurrentDevice.type) {
    return [];
  }

  return state;
};

const loadedForCurrentDevice = (state=false, action) => {
  if (action.type === loadGeozones.done.type) {
    return true;
  }
  if(action.type === changeCurrentDevice.type) {
    return false;
  }
  return state;
};

const currentGeozone = (state = defaultGeozone, action) => {
  if (action.type === editGeozoneClicked.type) {
    return action.payload.geozone;
  }
  if (action.type === updateGeozoneFinished.done.type) {
    return defaultGeozone;
  }
  if (action.type === changeCurrentDevice.type) {
    return defaultGeozone;
  }

  if (action.type === switchCurrentDevice.type) {
    return defaultGeozone;
  }
  if (action.type === toggleSettingsModal.type) {
    return defaultGeozone;
  }

  if (action.type === createGeozone.type) {
    return defaultGeozone;
  }

  if (action.type === toggleGeozoneEditor.type) {
    return defaultGeozone;
  }

  if (action.type === logoutButtonClick.type) {
    return defaultGeozone;
  }
  return state;
};

export default combineReducers({
  currentDeviceGeozones,
  currentGeozone,
  geozonesLoading,
  loadedForCurrentDevice,
});



// WEBPACK FOOTER //
// ./src/reducers/geozones.js